module.exports = __webpack_public_path__ + "static/media/guide_line_1.357dd638.png";